import { render, staticRenderFns } from "./MovieBlockedContainer.vue?vue&type=template&id=84449660&scoped=true&"
import script from "./MovieBlockedContainer.vue?vue&type=script&lang=js&"
export * from "./MovieBlockedContainer.vue?vue&type=script&lang=js&"
import style0 from "./MovieBlockedContainer.vue?vue&type=style&index=0&id=84449660&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84449660",
  null
  
)

component.options.__file = "MovieBlockedContainer.vue"
export default component.exports